module.exports = __webpack_public_path__ + "static/media/wave.a777eb18.svg";